export function seedBuddyFromList(buddy) {
  if (!buddy || typeof buddy !== 'object') return buddy;
  const clubs = buddy.profile?.clubs_summary || buddy.clubs_summary || [];
  return {
    ...buddy,
    profile: {
      ...(buddy.profile || {}),
      clubs_summary: Array.isArray(clubs) ? clubs : [],
    },
  };
}

export function mergeBuddyListWithProfiles(list, previousProfiles) {
  const prevById = new Map((previousProfiles || []).map((buddy) => [String(buddy.id), buddy]));
  return (list || []).map((buddy) => {
    const seeded = seedBuddyFromList(buddy);
    const prev = prevById.get(String(buddy.id));
    if (!prev?.profile) return seeded;
    const incoming = seeded.profile || {};
    const prior = prev.profile;
    const nextProfile = {
      ...prior,
      ...incoming,
      photo_url: incoming.photo_url || prior.photo_url,
      club_roles: incoming.club_roles?.length ? incoming.club_roles : (prior.club_roles || []),
      preferred_hunting_method:
        incoming.preferred_hunting_method || prior.preferred_hunting_method,
    };
    if (incoming.current_sign_out !== undefined || prior.current_sign_out !== undefined) {
      nextProfile.current_sign_out = incoming.current_sign_out ?? prior.current_sign_out ?? null;
    }
    if (incoming.last_sign_out !== undefined || prior.last_sign_out !== undefined) {
      nextProfile.last_sign_out = incoming.last_sign_out ?? prior.last_sign_out ?? null;
    }
    return {
      ...prev,
      ...seeded,
      profile: nextProfile,
    };
  });
}

export function buddyProfilesCoverList(list, previousProfiles) {
  if (!list?.length) return false;
  const prevById = new Map((previousProfiles || []).map((buddy) => [String(buddy.id), buddy]));
  return list.every((buddy) => {
    const prev = prevById.get(String(buddy.id));
    return Boolean(prev?.profile && ('last_sign_out' in prev.profile || prev.profile.current_sign_out));
  });
}

export function countSharedClubs(buddies) {
  const names = new Set();
  (buddies || []).forEach((buddy) => {
    const clubs = buddy?.profile?.clubs_summary || buddy?.clubs_summary || [];
    if (!Array.isArray(clubs)) return;
    clubs.forEach((name) => {
      if (name) names.add(name);
    });
  });
  return names.size;
}
